module.exports = __webpack_public_path__ + "img/hexagon.be5030ca.webp";